export type GlowLevelTypes = 'legendary' | 'rare' | 'primary';

export const getGlowLevel = (rhythmScore: number): GlowLevelTypes => {
    if (rhythmScore >= 90) return 'legendary';
    else if (rhythmScore >= 80) return 'rare';
    else return 'primary';
};
